module.exports = __webpack_public_path__ + "static/media/avatar.780caefb.jpeg";